module.exports = {"id":"163492","name":"Nicolas Lombaerts","rating":"75","photo":"./data/images/photos/4/163492.png","club":{"name":"KV Ostende","logo":"./data/images/clubs/KVOstende.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolasLombaerts0.json
// module id = 3201
// module chunks = 0